import polly from "polly-js";
import { LRUCache } from "lru-cache";

const cache = new LRUCache({
  //Max number of items to cache in memory
  max: 500,
  //Time to live in ms
  //3,600,000  ms = 1 hour
  ttl: 3600000
});

//Retrying won't fix an authorization failure
const NON_RETRYABLE_STATUSES = [401, 403];

const request = (url, options, shouldCache = false, rawResponse = false, shouldRetry = true) => {
  let retryValues = [500, 1000, 5000];
  if (!shouldRetry) {
    retryValues = [];
  }
  return polly()
    .logger(function (err) {
      console.error("error logging", err);
    })
    .handle(err => !NON_RETRYABLE_STATUSES.includes(err?.status))
    .waitAndRetry(retryValues)
    .executeForPromise(async () => {
      if (shouldCache && cache.has(url)) {
        return cache.get(url);
      } else {
        const rsp = await fetch(url, options);

        if (rsp.status === 200 || rsp.status === 304) {
          if (shouldCache) {
            const clone = rsp.clone();
            cache.set(url, clone.json());
          }
          if (rawResponse) return rsp;
          else return rsp.json();
        } else if (rsp.status === 204) {
          return;
        }

        //Some error responses (e.g. 401) come with an empty body
        const rspJson = await rsp.json().catch(() => null);

        return Promise.reject(
          {
            "status": rsp.status,
            "text": rsp.statusText,
            "url": rsp.url,
            rsp,
            rspJson
          }
        );
      }
    });
};

const buildSearchParams = (params) => {
  let searchParams = [];
  let queryString = "";

  for (const [key, value] of Object.entries(params)) {
    if (value) {
      searchParams.push(`${key}=${encodeURIComponent(value)}`);
    }
  }

  queryString = searchParams.join("&");

  return queryString;
};

export { request, buildSearchParams };